import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../../src/util/install_sentry'

import './site_common'

import 'Components/refosumu/basics/breadcrumb/component'

import 'Components/refosumu/subsidies/go_to_top/component'
import 'Components/refosumu/subsidies/heading/component'
import 'Components/refosumu/subsidies/accordion_content_with_heading/component'
import 'Components/refosumu/subsidies/mainvisual/component'
import 'Components/refosumu/subsidies/mainvisual_search_widget/component'
import 'Components/refosumu/subsidies/terms_section/component'
import 'Components/refosumu/subsidies/receiving_flow_section/component'
import 'Components/refosumu/subsidies/search_by_prefectures/component'
import 'Components/refosumu/subsidies/search_by_construction_parts/component'
import 'Components/refosumu/subsidies/side_search_widget/component'
import 'Components/refosumu/subsidies/summary_card/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'
import { setViewHeight } from '../../src/subsidies/components/setViewHeight'
import { changeCompleteStatusForSelect } from '../../src/subsidies/components/changeCompleteStatusForSelect'

window.$ = $

$(() => {
  // スマートフォンのハンバーガーメニュー処理
  spToggleNav()

  // スマホのメニューバーを考慮したvhを利用するために実行
  setViewHeight()
  window.addEventListener('resize', setViewHeight)

  // セレクトタグ用のプレースホルダー処理
  changeCompleteStatusForSelect()
})
